export default "__VITE_ASSET__ce3e2648__"